import { Typography } from '@mui/material';

interface Props {
    text?: string;
    isRequired?: boolean;
}

export const LabelAnswer = ({ text, isRequired = true }: Props) => {
    return (
        <Typography
            fontFamily="Lucida Sans"
            fontSize="1.2rem"
            fontWeight="700!important"
            textAlign="left"
            color="#36c"
            px={{ xs: 0, md: 12 }}
        >
            {text} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Typography>
    );
};
